import config from 'config';
import { authHeader } from '../_helpers';

export const authorizationService = {
    logout,
    getPermissions
};

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('token');
}

function getPermissions() {

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/permissions`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                if(response.url !== `${config.apiUrl}/auth/login`)
                    location.reload(true);
            }

            const error = "Invalid user or password entered. Try again." // (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}